import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import CooperativeList from "../components/cooperatives-list/CooperativeList";
import { useLoader } from "../context/LoaderContext";
import { ICooperative } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { fetchCooperative } from "../api/DashboardApi";
import { useUser } from "../context/UserContext";

const CooperativesListPage = () => {
  const { setLoading } = useLoader();
  const [cooperative, setCooperative] = useState<ICooperative[]>([]);
  const { user } = useUser();
  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchCooperative()])
      .then(([cooperativeData]) => {
        setCooperative(cooperativeData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
          <CooperativeList
            cooperative={cooperative}
            setCooperative={setCooperative}
          />
        </div>
      </PageLayout>
    </>
  );
};

export default CooperativesListPage;
